module.exports = function getResource(label, vars = []) {
    let resources = {
        nameError: 'Please fill out this field.',
        name: 'Name',
        edit: 'Edit',
        firstNameLabel: 'First name',
        lastNameLabel: 'Last name',
        cancel: 'Cancel',
        update: 'Update'
    };
    return resources[label];
};
